export default __webpack_public_path__ + "static/media/phone.ae907e63.svg";